import Head from 'next/head'
import Footer from '../components/Footer'

function FooterForBlog() {
    return (
        <>
            <Head>
                <meta name="robots" content="noindex,nofollow" />
            </Head>
            <Footer />
        </>
    )
}

export default FooterForBlog

export function getStaticProps() {
    return {
        props: {
            isComponent: true,
        },
        revalidate: 10, // In seconds
    }
}
